import React, { useEffect, useState } from "react";
import { useParams, useSearchParams, Link, useNavigate } from "react-router-dom";


import { Spinner, Alert, Table } from "react-bootstrap";
import { apiurl } from "../../Constants";
import axios from "axios";
import { toast } from "react-toastify";

function QuotationDetails() {
  const { id: paramId } = useParams();
const [searchParams] = useSearchParams();
const navigate = useNavigate();

const queryId = searchParams.get("id");

// supports /quotation?49
const rawQueryId = window.location.search.replace("?", "");

// ✅ final usable ID (supports ALL formats)
const id = queryId || paramId || rawQueryId;




  const [quotation, setQuotation] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  // ---------- STATES ----------
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);

  const [selectedState, setSelectedState] = useState("");
  const [selectedCity, setSelectedCity] = useState("");

  // ---------- Address Form States ----------
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [mobile, setMobile] = useState("");
  const [address, setAddress] = useState("");
  const [pincode, setPincode] = useState("");
  const [email, setEmail] = useState("");

  // ---------- Edit Mode ----------
  const [isEditing, setIsEditing] = useState(false);

  // ---------- FETCH STATES ----------
  useEffect(() => {
    const fetchStates = async () => {
      try {
        const response = await axios.post(apiurl + "state", { country_id: 1 });
        if (response.data.status === 200 || response.data.status === true) {
          setStates(response.data.data);
        }
      } catch (error) {
        console.log("State fetch error:", error);
      }
    };
    fetchStates();
  }, []);

  // ---------- FETCH CITY LIST ----------
  const fetchCity = async (state_id) => {
    try {
      const response = await axios.post(apiurl + "city", {
        country_id: 1,
        state_id: parseInt(state_id),
      });
      setCities(response.data.data);
    } catch (error) {
      console.log("City fetch error:", error);
    }
  };

  

  // ---------- FETCH QUOTATION ----------
  const fetchQuotationDetails = async () => {
    setLoading(true);
    try {
      const res = await fetch(`${apiurl}quotation_details`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id }),
      });
      const data = await res.json();
    if (data.success && data.data) {
  setQuotation(data.data);
  setSelectedState(data.data.state_id);
  setSelectedCity(data.data.city_id);
  fetchCity(data.data.state_id);
} else {
  navigate("*", { replace: true });
}

    } catch (err) {
      console.error(err);
      setError("Something went wrong while fetching data.");
    } finally {
      setLoading(false);
    }
  };

useEffect(() => {
  if (!id) return;
  fetchQuotationDetails();
}, [id]);


  if (!id) {
  return (
    <Alert variant="danger" className="text-center mt-5">
      Invalid quotation link
    </Alert>
  );
}



  // ---------- HANDLE SAVE OR UPDATE ADDRESS ----------
  const handleSaveAddress = async () => {
    if (!firstName || !lastName || !mobile || !address || !selectedCity || !pincode || !email) {
      toast.error("Please fill all fields");
      return;
    }

    if (!quotation?.web_user_id) {
      toast.error("User ID not found. Cannot save address.");
      return;
    }

    const addAddressData = {
      user_id: quotation.web_user_id,
      first_name: firstName,
      last_name: lastName,
      address: address,
      state_id: selectedState,
      city_id: selectedCity,
      pin_code: pincode,
      email_id: email,
      phone_number: mobile,
      quotation_id: id,
    };

    try {
      const response = await axios.post(apiurl + "add_address", addAddressData);

      if (response.status === 200 && response.data.address?.id) {
        const addressId = response.data.address.id;
        toast.success("Address Saved Successfully!", { autoClose: 2000 });

        const quotationUpdateData = {
          quotation_id: id,
          address_id: addressId,
        };

        await axios.post(apiurl + "quotation_address_update", quotationUpdateData);

        // Clear form and exit edit mode
        setFirstName("");
        setLastName("");
        setMobile("");
        setAddress("");
        setPincode("");
        setEmail("");
        setIsEditing(false);

        fetchQuotationDetails(); // refresh quotation
      } else {
        toast.error("Failed to save address.");
      }
    } catch (error) {
      console.log(error);
      toast.error("Something went wrong while saving address.");
    }
  };




const quotationPaymentSuccess = async () => {
  try {
    if (!isAddressValid) {
      toast.error("Please add shipping address", { autoClose: 2000 });
      return;
    }

    /* ---------------- PLACE QUOTATION ORDER ----------------
       Backend places the order AND builds the SenangPay hash,
       returning a ready-to-use payment URL. Just redirect to it. */
    const orderRes = await axios.post(apiurl + "quotation_place_order", {
      quotation_id: id,
    });

    const { order_id, url } = orderRes.data || {};

    if (!order_id || !url) {
      toast.error("Order creation failed. Please try again.");
      return;
    }

    // Redirect browser to SenangPay's hosted payment page
    window.location.href = url;
  } catch (error) {
    console.error("Quotation payment error:", error);
    toast.error("Something went wrong. Please try again.");
  }
};



  if (loading)
    return (
      <div className="d-flex justify-content-center py-5">
        <Spinner animation="border" variant="success" />
      </div>
    );

 const hasDiscount =
  quotation?.product_details?.some(
    (p) => Number(p.product_discount) > 0
  ) || false;


  if (error)
    return (
      <Alert variant="danger" className="text-center">
        {error}
      </Alert>
    );

  const showAddress = quotation.address_id > 0 ? quotation.address_details : null;
 const isAddressValid = quotation?.address_id > 0 && quotation?.address_details;

const isPaymentDone =
  Number(quotation?.payment_status) === 1 ||
  Number(quotation?.payment_status) === 2;

const canPay = Number(quotation?.payment_status) === 0;


if (isPaymentDone) {
  return (
    <div className="container-fluid min-vh-100 d-flex align-items-center justify-content-center bg-light">
      <div className="text-center p-5 bg-white shadow rounded">
        <h1 className="text-success fw-bold mb-3">
          ✅ Payment Completed
        </h1>

        <p className="fs-5 mb-2">
          This quotation has already been paid.
        </p>

        <p className="mb-3">
          <strong>Quotation ID:</strong> {quotation.quotation_id}
        </p>

        {quotation.payment_details && (
          <>
            {/* <p>
              <strong>Transaction ID:</strong>{" "}
              {quotation.payment_details.payment_id}
            </p>
            <p>
              <strong>Payment Mode:</strong>{" "}
              {quotation.payment_details.payment_mode}
            </p> */}
            <p>
              <strong>Payment Time:</strong>{" "}
              {quotation.payment_details.payment_time}
            </p>
          </>
        )}

        <div className="mt-4">
          <Link to="/" className="btn btn-success px-4">
            back
          </Link>
        </div>
      </div>
    </div>
  );
}


  return (
    <div className="container my-5">
      <div className="border shadow-sm p-4 bg-white rounded">
        {/* Header */}
        <div className="d-flex justify-content-between align-items-center mb-4 flex-column flex-md-row">
          <h2 className="text-success fw-bold">Quotation / Invoice</h2>
          <Link to="/account" className="btn btn-outline-success mt-3 mt-md-0">
            &larr; Back
          </Link>
        </div>

        <Table>
          <tbody>
            <tr>
              <td className="fw-bold">
                Quotation Id: <span className="fw-normal"> &nbsp;&nbsp;&nbsp; {quotation.quotation_id}</span>{" "}
              </td>
            </tr>
          </tbody>
        </Table>

        {/* Product Table */}
        <Table bordered responsive className="mb-4">
          <thead className="table-dark text-center align-middle">
            <tr>
              <th>#</th>
              <th>Product Name</th>
              <th>Qty</th>
              <th>Cost (RM)</th>
              {hasDiscount && <th>Discount</th>}
              {/* <th>Tax</th> */}
              <th>Total (RM)</th>
            </tr>
          </thead>
          <tbody>
            {quotation.product_details.map((p, idx) => (
              <tr key={idx} className="text-center align-middle">
                <td>{idx + 1}</td>
                <td>{p.product_name}</td>
                <td>{p.quantity}</td>
                <td>{Number(p.cost).toFixed(1)}</td>
             {hasDiscount && <td>{p.product_discount}</td>}

                {/* <td>{p.gst}</td> */}
                <td>{p.total_cost_with_gst}</td>
              </tr>
            ))}
          </tbody>
        </Table>

        {/* Address + Totals Side by Side */}
        <div className="row">
          {/* Left Column: Address */}
          <div className="col-md-6 mb-4">
            <h5 className="fw-bold mb-3">Shipping Address</h5>

            {showAddress && !isEditing ? (
              <div className="border p-3 rounded bg-light">
                <p>
                  <strong>Name:</strong> {showAddress.first_name} {showAddress.last_name}
                </p>
                <p>
                  <strong>Address:</strong> {showAddress.address}
                </p>
                <p>
                  <strong>City:</strong> {showAddress.city_name} <strong>State:</strong> {showAddress.state_name}
                </p>
                <p>
                  <strong>Pincode:</strong> {showAddress.pin_code}
                </p>
                <p>
                  <strong>Email:</strong> {showAddress.email_id}
                </p>
                <p>
                  <strong>Mobile:</strong> {showAddress.phone_number}
                </p>

                <button
                  className="btn btn-outline-success mt-2"
                  onClick={() => {
                    // Populate form fields for editing
                    setFirstName(showAddress.first_name);
                    setLastName(showAddress.last_name);
                    setMobile(showAddress.phone_number);
                    setAddress(showAddress.address);
                    setPincode(showAddress.pin_code);
                    setEmail(showAddress.email_id);
                    setSelectedState(showAddress.state_id);
                    setSelectedCity(showAddress.city_id);
                    fetchCity(showAddress.state_id);
                    setIsEditing(true);
                  }}
                >
                  Edit
                </button>
              </div>
            ) : (
              <div className="border p-3 rounded bg-light">
                {!showAddress && <p className="text-danger fw-semibold">No address found. Please fill your address:</p>}

                <div className="row">
                  <div className="col-md-6 mb-3">
                    <label className="form-label">First Name</label>
                    <input
                      type="text"
                      className="form-control"
                      value={firstName}
                      onChange={(e) => setFirstName(e.target.value)}
                      placeholder="Enter first name"
                    />
                  </div>
                  <div className="col-md-6 mb-3">
                    <label className="form-label">Last Name</label>
                    <input
                      type="text"
                      className="form-control"
                      value={lastName}
                      onChange={(e) => setLastName(e.target.value)}
                      placeholder="Enter last name"
                    />
                  </div>
                  <div className="col-12 mb-3">
                    <label className="form-label">Mobile Number</label>
                    <input
                      type="text"
                      className="form-control"
                      value={mobile}
                      onChange={(e) => setMobile(e.target.value)}
                      placeholder="Enter your mobile number"
                    />
                  </div>
                  <div className="col-12 mb-3">
                    <label className="form-label">Address</label>
                    <textarea
                      className="form-control"
                      rows="2"
                      value={address}
                      onChange={(e) => setAddress(e.target.value)}
                      placeholder="Street, Area"
                    ></textarea>
                  </div>
                  <div className="col-md-6 mb-3">
                    <label className="form-label">State</label>
                    <select className="form-control" value={selectedState} disabled>
                      <option value="">Select State</option>
                      {states.map((s) => (
                        <option key={s.id} value={s.id}>
                          {s.state_name}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-md-6 mb-3">
                    <label className="form-label">City</label>
                    <select
                      className="form-control"
                      value={selectedCity}
                      onChange={(e) => setSelectedCity(e.target.value)}
                    >
                      <option value="">Select City</option>
                      {cities.map((c) => (
                        <option key={c.id} value={c.id}>
                          {c.city_name}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-md-6 mb-3">
                    <label className="form-label">Pincode</label>
                    <input
                      type="text"
                      className="form-control"
                      value={pincode}
                      onChange={(e) => setPincode(e.target.value)}
                      placeholder="Enter pincode"
                    />
                  </div>
                  <div className="col-md-6 mb-3">
                    <label className="form-label">Email</label>
                    <input
                      type="email"
                      className="form-control"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      placeholder="Enter email"
                    />
                  </div>
                </div>

                <button className="btn btn-success mt-2" onClick={handleSaveAddress}>
                  {showAddress ? "Update Address" : "Save Address"}
                </button>
              </div>
            )}
          </div>

          {/* Right Column: Totals */}
          <div className="col-md-6 mb-4">
            <table className="table table-borderless">
              <tbody>
                <tr>
                  <th>Total Quantity:</th>
                  <td>{quotation.totalQuantity}</td>
                </tr>
                <tr>
                  <th>Total Cost:</th>
                  <td>RM {quotation.totalCost}</td>
                </tr>
                <tr>
                  <th>Total Cost with GST:</th>
                  <td>RM {quotation.totalCostWithGST}</td>
                </tr>
                <tr>
                  <th>Shipping Charges:</th>
                  <td>RM {quotation.shipping_amount}</td>
                </tr>
              {Number(quotation.discount_value) > 0 && (
  <tr>
    <th>Discount:</th>
    <td>RM {quotation.discount_value}</td>
  </tr>
)}

              {Number(quotation.cash_discount) > 0 && (
  <tr>
    <th>Cash Discount:</th>
    <td>RM {quotation.cash_discount}</td>
  </tr>
)}
<tr className="fw-bold fs-5" style={{ borderTop: "2px solid #000" }}>
  <th>Grand Total:</th>
  <td>RM {quotation.grand_total}</td>
</tr>

              </tbody>
            </table>
          </div>
        </div>

        {quotation.remarks && (
          <div className="mt-4">
            <h6>Remarks:</h6>
            <p>{quotation.remarks}</p>
          </div>
        )}
<div className="d-flex justify-content-end mt-4">
  {isAddressValid ? (
    <button
      className="btn btn-success px-4"
      onClick={quotationPaymentSuccess}
    >
      Pay Now
    </button>
  ) : (
    <button
      className="btn btn-success px-4 opacity-50"
      onClick={() =>
        toast.error("Please add your shipping address before payment")
      }
    >
      Pay Now
    </button>
  )}
</div>




      </div>
    </div>
  );
}

export default QuotationDetails;